import { useEffect, useState } from 'react';
import { User, Session } from '@supabase/supabase-js';
import { supabase } from '@/integrations/supabase/client';

export const useAuth = () => {
  const [user, setUser] = useState<User | null>(null);
  const [session, setSession] = useState<Session | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Set up auth state listener FIRST
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (event, session) => {
        setSession(session);
        setUser(session?.user ?? null);
        setLoading(false);
      }
    );

    // THEN check for existing session
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setUser(session?.user ?? null);
      setLoading(false);
    });

    return () => subscription.unsubscribe();
  }, []);

  const signIn = async (email: string, password: string, captchaToken?: string) => {
    const options: any = {};
    if (captchaToken) {
      options.captchaToken = captchaToken;
    }
    
    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
      options
    });
    return { error };
  };

  const signUp = async (email: string, password: string, captchaToken?: string) => {
    const redirectUrl = `${window.location.origin}/`;
    
    const options: any = {
      emailRedirectTo: redirectUrl
    };
    if (captchaToken) {
      options.captchaToken = captchaToken;
    }
    
    const { error } = await supabase.auth.signUp({
      email,
      password,
      options
    });
    return { error };
  };

  const signOut = async () => {
    const { error } = await supabase.auth.signOut();
    return { error };
  };

  // Check if user is admin (your specific email)
  const isAdmin = user?.email === 'wainofficialmusic@gmail.com';

  return {
    user,
    session,
    loading,
    signIn,
    signUp,
    signOut,
    isAdmin,
    isAuthenticated: !!session
  };
};